<script setup lang="ts">
import { useI18n } from "vue-i18n";

import Cross from "@/Components/Icons/Cross.vue";
import InfoCircle from "@/Components/Icons/InfoCircle.vue";

import { isAndroidApp, isIosApp } from "@/Utils/Ionic";

const { t } = useI18n();

const emit = defineEmits<{
  (event: "close"): void;
}>();
</script>

<template>
  <div
    class="banner"
    :class="{ 'ios_grid_app-top-important': isIosApp(), 'android_grid_app-top-important': isAndroidApp() }"
  >
    <InfoCircle color="content-inverse" class="mr-2" />

    <p>
      <b>{{ `${t("general.chat.videocall.notification.part_1")}.` }}</b> &nbsp;
      {{ t("general.chat.videocall.notification.part_2") }}
    </p>

    <Cross color="content-inverse" class="ml-auto c-pointer" @click="emit('close')" />
  </div>
</template>

<style scoped lang="scss">
.banner {
  @include sp.padding(r, 3);
  @include sp.padding(l, 11);
  @include sp.padding(y, 3);
  @include colors.bg(content, high);
  @include text.general(low, xl);
  @include colors.color(content, inverse);
  @include radius(s);

  display: flex;
  align-items: center;
  opacity: 0.82;

  p {
    opacity: 1;

    u {
      cursor: pointer;
    }
  }
}
</style>
